var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { Slot } from "@/utils/types/layout";
import { useSlotVisibility } from "@/hooks/layout";
import AddWidgetControl from "@/components/layout/edit/addWidget";
import WidgetGrid from "../widgetGrid";
import { useFilteredWidgets } from "@/utils/themes/hooks";
/**
 *
 * Composant DockSouth
 */
export default function DockSouth() {
    var dockSouthVisible = useSlotVisibility().dockSouthVisible;
    var filteredWidgets = useFilteredWidgets(Slot.DOCK_SOUTH);
    var isEditingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var areaVisible = (dockSouthVisible && filteredWidgets.length > 0) || isEditingLayout;
    if (areaVisible) {
        if (filteredWidgets.length === 0 && !isEditingLayout) {
            return _jsx(_Fragment, {});
        }
        return (_jsxs("div", __assign({ className: " ".concat(isEditingLayout && "border-[2px] border-[var(--colors-widget-border)]", " flex-none flex bg-[var(--colors-dock-south-bg)] direction-horizontal scroll-contain relative w-full h-[16rem] overflow-hidden\n      mt-[var(--margin-mt-dock-south)] mr-[var(--margin-mr-dock-south)]\n      mb-[var(--margin-mb-dock-south)] ml-[var(--margin-ml-dock-south)]") }, { children: [_jsx("div", __assign({ className: "relative w-full h-full overflow-hidden widgets-container scroll-elements" }, { children: _jsx(WidgetGrid, { filteredWidgets: filteredWidgets, isEditingLayout: isEditingLayout }) })), isEditingLayout && _jsx(AddWidgetControl, { to: Slot.DOCK_SOUTH })] })));
    }
    return _jsx(_Fragment, {});
}
